import React from 'react'
import '../css/global.css'
import { ReactComponent as Err } from '../img/404.svg'
//import err from "../img/icons/pageintrouvable.svg"
import {Button} from '@mui/material';

export default function Digitalisation() {
    return (

<div className="container-error" >
            <div className="error-template">
                <Err alt="err" id='err' />  
                {/* //<h1>Page introuvable</h1>       */}
                <div className="error-content">
                    <p className='Title-err' >
                        { "Oops, il semble que l'adresse que vous avez introduite est fausse. revenez à l'acceuil."}
                    </p> 
                </div>     
                
               
                
                <Button variant="contained" className='Btn-acceuil-err'  onClick={()=>window.location=('/')} >Retour à l'accueil </Button>          
               
            </div>
</div>

    )
}
